<template>
  <div class="detail-list-item" @click="handle(item.detail_mobile_url)">
    <h4 class="ell">【{{ item.category_name }}】{{ item.item_name }}</h4>
    <p class="ell">来源: {{ item.source_name }}</p>
    <p class="ell">发起时间: {{ item.send_time }}</p>
    <p class="ell">办理时间: {{ item.receive_time }}</p>
  </div>
</template>

<script>
export default {
  name: "DetailListItem",
  props: ['item'],
  methods: {
    handle(link) {
      location.href = link;
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-list-item {
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  background: #fff;
  
  h4 {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
  
  p {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #999;
  }
}

.ell{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
